import React, { useEffect, useRef, useState } from "react"

import { useTranslation } from "react-i18next";
import MainLinks from "../../components/navlinks/MainLinks";
import Body from "../../components/body/BodyPage";
import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBSpinner } from "mdb-react-ui-kit";
import AddLuna from "../popups/Luna/AddLuna";
import { useLocation, useNavigate } from "react-router";
import { getLunaProfileList } from "../../apiclients/streamsapi_bridge";
import { formattedNumber } from "../popups/phonenumbers/AddRemoveNumbers";
import PopupLoaderNew from "../popups/PopupLoaderNew";
import RemoveLunaProfile from "../popups/Luna/RemoveLunaProfile";
import { Tooltip } from "react-tooltip";
import { getAssocCFDataByEntityIdNodeType } from "../../components/topviews/Users";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import TabIDConstant from "../../apiclients/TabIDConstant";
import ImportProgressWarning from "../../apiclients/ImportProgressWarning";
import { getImpExpStatusNew } from "../../apiclients/CommonUtils";
import ImpExpRedirectPopup from "../../apiclients/ImpExpRedirectPopup";
import ImportUser from "../../components/editviews/user/ImportUser";
function LunaLanding() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [basicModal, setBasicModal] = useState(location.state ? location.state.openadd : false);
    const toggleOpen = () => {
        window.history.replaceState({}, document.title);
        setBasicModal(!basicModal);
    }
    const navigate = useNavigate();
    const [lunaPList, setLunaPList] = useState([]);
    const [isloading, setIsloading] = useState(true);
    const [deleteLuna, setDeleteLuna] = useState(false);
    const dtogglePopup = () => setDeleteLuna(!deleteLuna);
    const [lunaId, setlunaId] = useState("");
    const [isLoading, setisLoading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const [assocCallFlows, setAssocCallFlows] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [lunaDetails, setLunaDetails] = useState([]);
    const lunaProfileRef = useRef(null);
    const [showExportWarning, setShowExportWarning] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false); 
     const searchRef = useRef(null);
    const exportwarningToggle = () => setShowExportWarning(!showExportWarning);
    const [warningMessage, setWarningMessage] = useState("");
    const [showImpExpRedirect, setShowImpExpRedirect] = useState(false);
    const [importUser, setimportUser] = useState(false);
    const importuserToggle = () => setimportUser(!importUser);
    const [firstRequest, setfirstRequest] = useState(false);
    function handleLunaProfile() {
        lunaProfileRef.current.click();
    }

    const voiceTypeLabels = {
        1: 'Luna',
        2: 'Eric',
        3: 'Oscar',
        4: 'Serena'
    };

    useEffect(() => {
        fetchLunaList();

    }, []);


      useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('.luna-table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (trimmed && td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles(); // Initial patch

        const table = document.querySelector('.luna-table');
        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

    const fetchLunaList = async () => {
        setInternalError(false);
        setIsloading(true);
        const response = await getLunaProfileList(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            TabIDConstant.LUNA_AI_LINK
        );
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            setInternalError(true);
        }
        console.log("response data is :::::::::: " + JSON.stringify(rawData));
        setLunaPList(rawData?.LunaProfiles ?? []);

    }

    useEffect(() => {
        let processdrows = [];
        lunaPList.map((info) => {
            let phNumber = info.phnumber ? formattedNumber(info.phnumber) + "" : ""
            processdrows.push({
                lunaInfo: info,
                name: info.name,
                extension: info.extension,
                number: info?.phnumber_count > 1 ? phNumber + ", ..." : phNumber,
                voice_type: info.voice_type ? voiceTypeLabels[info.voice_type] : '',
                actualNumber: phNumber?.toString().replace(/[ ]/g, ''),
                location_name: info.location_name,
                phNumber: info.phnumber + "" ?? "",

                actions: (
                    <>
                        <div className="d-flex align-items-center justify-content-center">
                            <div
                                className="custom-hover-bg p-1 cursor-pointer deleteToolTip ms-2"
                                onClick={(e) => deleteLunaProfile(e, info.lunaid)}
                            >
                                <MDBIcon
                                    fas
                                    icon="times"
                                    color="primary"
                                    className="mx-2 my-1 fs-5"
                                />
                            </div>
                        </div>
                    </>
                ),

            })
        })
        setFilteredRows(processdrows)
        setLunaDetails(processdrows)
         setDataLoaded(true)
    }, [lunaPList])

    const actionData = {
        columns: [
            { label: "Name", field: "name", sort: true },
            { label: "Extension", field: "extension", sort: true },
            { label: "Number", field: "number", sort: true },
            { label: "Voice", field: "voice_type", sort: true },
            { label: "Location", field: "location_name", sort: true },
            { label: "Remove", field: "actions", sort: false },
        ],
        rows: lunaDetails,
    };

    const handleManualSearch = (searchValue) => {
        setSearchValue(searchValue);
        const filtered = customSearch(lunaDetails, searchValue, UIConstant.LUNA_LANDING);

        setFilteredRows(filtered);
    };
    async function deleteLunaProfile(evntData, id) {
        evntData.preventDefault();
        evntData.stopPropagation();
        await fetchCFdata(id);
        dtogglePopup();
        setlunaId(id);
    }

    async function fetchCFdata(id) {
        console.log("Inside fetch data ", id)
        let associatedCF = await getAssocCFDataByEntityIdNodeType(JSON.parse(sessionStorage.getItem("admin_session")).siteid, id, 12);
        console.log("Cf association :::", associatedCF)
        setAssocCallFlows(associatedCF?.associated_callflows ?? []);
    }





    const showThisInfo = (tdata) => {
        navigate("/luna-settings", {
            state: tdata.lunaInfo,
        });
    }


    useEffect(() => {
        const patchTitles = () => {
            const tds = document.querySelectorAll('table td');
            tds.forEach(td => {
                const trimmed = td.textContent.trim();
                if (!td.getAttribute('title') || td.getAttribute('title') !== trimmed) {
                    td.setAttribute('title', trimmed);
                }
            });
        };

        patchTitles();

        const table = document.querySelector('.LunaData-Table');

        if (!table) return;

        const observer = new MutationObserver(() => {
            patchTitles();
        });

        observer.observe(table, {
            childList: true,
            subtree: true,
        });

        return () => observer.disconnect();
    }, []);

const handleImportAndPrgress = async(e) => {
          e.preventDefault();
          const result = await getImpExpStatusNew();
          if (result.status === 0) {
            toggleOpen();
          } else if (result.isOwnUser) {
            setShowImpExpRedirect(true);
          } else {
            const { userInfo } = result;
            if (userInfo?.isaccount) {
              setWarningMessage(t("imp_exp_account_progress", { name: userInfo.name ?? "" }));
            } else {
              setWarningMessage(t("imp_exp_other_user_progress", { name: userInfo?.name ?? "" }));
            }
            exportwarningToggle();
          }
        }


    return (
        <React.Fragment>
            <>
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={42}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3">
                                        <h5 className="mb-0 ">
                                            Luna
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className=" actionbar">
                                            <MDBBtn
                                                onClick={(e) => handleImportAndPrgress(e)}
                                                className="float-end mt-6px"
                                            >
                                                <MDBIcon fas icon="plus" className="me-2" />
                                                Add Luna
                                            </MDBBtn>
                                        </div>
                                        <div className='mb-2 mt-0 position-relative w-auto'>
                                            <MDBInput
                                                label="Search"
                                                value={searchValue}
                                                ref={searchRef}
                                                onChange={(e) => handleManualSearch(e.target.value)}
                                            />
                                            <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                        </div>
                                        <div className="callFlowTable">
                                            <MDBDatatable
                                                fixedHeader
                                                sortField="Name"
                                                className="actioncolumnbig LunaData-Table"
                                                // search
                                                key={searchValue}
                                                entries={50}
                                                data={{
                                                    ...actionData,
                                                    rows: filteredRows
                                                }
                                                }
                                                onRowClick={(event) => {
                                                    showThisInfo(event);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {basicModal && (
                                <PopupLoaderNew
                                    title={"Add Luna Profile"}
                                    content={<AddLuna
                                        lunaId={lunaId}
                                        onClose={toggleOpen}
                                        ref={lunaProfileRef}
                                        setIsloading={setisLoading}
                                    />}
                                    onShow={setBasicModal}
                                    onClose={toggleOpen}
                                    onSave={handleLunaProfile}
                                    isloading={isLoading}
                                    flag={1}
                                />
                            )}







                        </>
                    }
                />

                {deleteLuna && (
                    <PopupLoaderNew
                        title={"Remove Luna Profile"}
                        content={<RemoveLunaProfile
                            lunaId={lunaId}
                            onClose={dtogglePopup}
                            ref={lunaProfileRef}
                            setIsloading={setisLoading}
                            assocCFData={assocCallFlows}
                        />}
                        onShow={setDeleteLuna}
                        onClose={dtogglePopup}
                        onSave={handleLunaProfile}
                        isloading={isLoading}
                        flag={assocCallFlows.length == 0 ? 4 : 10}
                    />
                )}

                {showExportWarning && (
                <ImportProgressWarning
                  warningToggle={exportwarningToggle}
                  setShowWarning={setShowExportWarning}
                  onOk={exportwarningToggle}
                  message={warningMessage}
                />

                )}

                {showImpExpRedirect && (
                  <ImpExpRedirectPopup
                    onProceed={() => {
                      setShowImpExpRedirect(false);
                      setfirstRequest(true);
                      importuserToggle();
                    }}
                    onCancel={() => setShowImpExpRedirect(false)}
                  />
                )}

                <MDBModal open={importUser} onClose={() => setimportUser(false)} tabIndex='-1'>
                  <MDBModalDialog size="fullscreen">
                    <MDBModalContent>
                      <MDBModalHeader>
                        <MDBModalTitle>Import User Template</MDBModalTitle>
                      </MDBModalHeader>
                      <MDBModalBody className="pb-0">
                        <ImportUser
                          onClose={importuserToggle}
                          setIsloading={setisLoading}
                          onShow={setimportUser}
                          show={importUser}
                          firstRequest={firstRequest}
                          setfirstRequest={setfirstRequest}
                        />
                      </MDBModalBody>
                    </MDBModalContent>
                  </MDBModalDialog>
                </MDBModal>


                {internalError && (<MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                >Internal Server Error</MDBAlert>)}

                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
            </>
        </React.Fragment>
    )
}


export default LunaLanding
